import styled, { css } from 'styled-components';

import Spinner from 'components/Icons/Spinner';
import colors from 'utils/colors';
import device from 'utils/device';

import { ComponentProps, TextProps } from './interfaces';

export const TextWrapper = styled.div<TextProps>`
  pointer-events: none;
  height: 24px;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.3px;
  text-align: center;
  color: ${colors.white};

  @media ${device.isDesktop}, ${device.isTablet} {
    height: 24px;
    letter-spacing: -0.3px;
  }

  ${props =>
    props.disabled
      ? css`
          color: ${colors.white};
        `
      : css`
          :hover,
          :focus {
            color: ${colors.brown};
          }
        `}
  ${props =>
    props.buttonType === 'secondary' &&
    css`
      color: ${colors.orange};

      :hover,
      :focus {
        color: ${colors.brown};
      }
    `}
  ${props =>
    props.buttonType === 'tertiary' &&
    css`
      color: ${colors.blueGrey};
      border-bottom: 3px solid ${colors.orange};

      :hover,
      :focus {
        color: ${colors.orange};
      }
    `}
`;

export const ButtonWrapper = styled.button.attrs(props => ({
  type: props.type || 'button'
}))<ComponentProps>`
  transition: all 0.5s ease-out;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-family: VIC;
  box-sizing: border-box;
  vertical-align: middle;
  word-break: break-all;
  flex-wrap: nowrap;
  min-height: 50px;
  cursor: pointer;
  border-radius: 2px;
  background-color: ${colors.orange};
  border: solid 1px ${colors.orange};

  &:focus,
  &::-moz-focus-inner {
    border: none;
  }

  @media ${device.isTablet}, ${device.isDesktop} {
    padding-left: 13px;
    padding-right: 13px;
    min-width: 160px;
  }

  @media ${device.isMobile} {
    min-width: 200px;
    width: 100%;
  }

  ${props =>
    props.disabled
      ? css`
          cursor: not-allowed;
          opacity: 60%;
        `
      : css`
          :hover,
          :focus {
            border: solid 1px ${colors.brown};
            background-color: ${colors.brown};
          }
        `}
  ${props =>
    props.buttonType === 'secondary' &&
    css`
      border: solid 1px ${colors.orange};
      background-color: ${colors.white};

      :hover,
      :focus {
        border: solid 1px ${colors.orange25};
        background-color: ${colors.orange25};

        ${TextWrapper} {
          color: ${colors.brown};
        }
      }
    `}
    ${props =>
      props.buttonType === 'tertiary' &&
      css`
      border: none;
      background-color: transparent;

      :hover,
      :focus {
        border: none;
        background-color: transparent;

        ${TextWrapper} {
          color: ${colors.orange};
        }
      }
    `};
`;

export const LoadingSpinner = styled(Spinner)`
  margin-left: 8px;
  width: 16px;
  height: 16px;
  margin-bottom: -2px;
`;
